var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          ref: "propertiesDropdown",
          staticClass: "select-properties-dropdown",
          attrs: {
            size: "sm",
            variant: "primary",
            text: "Actions",
            "menu-class": "p-0",
            left: _vm.isBannerBuilder,
          },
          on: { show: _vm.onDropdownOpen, hide: _vm.onDropdownClose },
        },
        [
          _c(
            "b-list-group",
            [
              _vm._l(_vm.getProperties, function (property, index) {
                return _c(
                  "b-list-group-item",
                  { key: index },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: { size: "sm" },
                        on: {
                          change: function ($event) {
                            return _vm.onChangeProperties(property)
                          },
                        },
                        model: {
                          value: property.value,
                          callback: function ($$v) {
                            _vm.$set(property, "value", $$v)
                          },
                          expression: "property.value",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(property.text) + "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "b-list-group-item",
                {
                  class: [
                    "d-flex justify-content-end",
                    _vm.isBannerBuilder ? "flex-column" : "",
                  ],
                },
                [
                  _vm.selectedProperties.length && !_vm.isBannerBuilder
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { size: "sm", variant: "outlined" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.resetProperties.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("\n          Reset\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedProperties.length && _vm.isBannerBuilder
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-2",
                          attrs: { size: "sm", variant: "outlined" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.resetProperties.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("\n          Deselect All\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedProperties.length === 0 && _vm.isBannerBuilder
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-2",
                          attrs: { size: "sm", variant: "outlined" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.selectAllProperties.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Select All\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "primary",
                        disabled: !_vm.selectedProperties.length,
                      },
                      on: { click: _vm.apply },
                    },
                    [_vm._v("\n          Apply\n        ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }